import { useQuery } from 'react-query';
import { QUERY_KEYS } from '@constants';
import { fetchHealthCheckInfo, fetchAuthUser } from '@services';

/* Custom hook wrappers around react query queries */

const { healthCheckQuery, userQuery } = QUERY_KEYS;

export const useHealthCheckQuery = () => useQuery(healthCheckQuery, fetchHealthCheckInfo);
export const useAuthUserQuery = () => useQuery(userQuery, fetchAuthUser, 
    {
        cacheTime: 0,
        retry: false
    }
);
